import {Hive} from "widgets/hive";

const HivePage = () => {
    return (
        <>
            <Hive/>
        </>
    );
};

export default HivePage;